var map = {
	"./listUpdates": "./src/updates/listUpdates.js",
	"./listUpdates.js": "./src/updates/listUpdates.js",
	"./update02112023": "./src/updates/update02112023.js",
	"./update02112023.js": "./src/updates/update02112023.js",
	"./update07012025": "./src/updates/update07012025.js",
	"./update07012025.js": "./src/updates/update07012025.js",
	"./update18102023": "./src/updates/update18102023.js",
	"./update18102023.js": "./src/updates/update18102023.js",
	"./update25012024": "./src/updates/update25012024.js",
	"./update25012024.js": "./src/updates/update25012024.js"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/updates sync recursive ^\\.\\/.*$";